<div *ngIf="project.status === 'published' || project.publisheddate" class="project-sidebar-performance"
	[ngClass]="mode + '-mode'" [class.mode-sidebar]="mode === 'sidebar'">
	<h3 *ngIf="mode === 'sidebar'">{{ 'PERFORMANCE_MONTH_TO_DATE' | translate }}</h3>
	<div *ngIf="isLoading" class="kpi-container">
		<div class="stats-block">
			<div class="count">
				&nbsp;
			</div>
			<div class="title">
				{{ 'LOADING' | translate }}...
			</div>
		</div>
	</div>
	<div *ngIf="!isLoading && project?.kpiCalculations && kpis?.length" class="kpi-container">
		<ng-container *ngFor="let kpi of kpis;let i = index">
			<bb-kpi-block *ngIf="showAllKpis || mode !== 'sidebar' || kpi.isImportant || kpi.isDefault" [kpi]="kpi"
				[project]="project" [mode]="mode" [statsConfiguration]="configuration"
				[selected]="selectedKPI && kpi.id === selectedKPI.id" (selectedBlock)="selectKPI($event)">
			</bb-kpi-block>
		</ng-container>
	</div>
	<div class="goto-btn" *ngIf="mode === 'sidebar'">
		<a class="button" [routerLink]="['/analytics/project/', project.id]">
			<i class="fa fa-line-chart"></i>
			<span class="short-label">{{ 'GO_TO_PROJECT_ANALYTICS' | translate }}</span>
		</a>
	</div>
</div>
